import { CompanySizeTierEnum } from '../../../enums/company-size-tier.enum';
import { FLUENT_UI_EMOJIS } from '../../../assets';

export const COMPANY_SIZE_ICON_MAP = {
  [CompanySizeTierEnum.Small]: FLUENT_UI_EMOJIS.SEEDLING,
  [CompanySizeTierEnum.Medium]: FLUENT_UI_EMOJIS.HERB,
  [CompanySizeTierEnum.Large]: FLUENT_UI_EMOJIS.EVERGREEN_TREE,
  [CompanySizeTierEnum.VeryLarge]: FLUENT_UI_EMOJIS.DECIDUOUS_TREE,
};
